import { type FC } from 'react'

import {
  ACTIONS,
  DESCRIPTIONS,
  ERROR_MESSAGES,
  MENU,
  SUCCESS_MESSAGES
} from '@/constants/common/message.constants'
import { createPackageCategoryImportJob } from '@/features/package-category-import-jobs/api'

import { isOpenPackageCategoryImportModalAtom } from '../../-states'
import { CsvImportModal } from '../CsvImportModal/CsvImportModal'

type Props = {
  tenantKey: string
}

/**
 * 荷姿マスタインポートModal
 */
export const PackageCategoryImportModal: FC<Props> = ({ tenantKey }) => {
  return (
    <CsvImportModal
      tenantKey={tenantKey}
      isOpenAtom={isOpenPackageCategoryImportModalAtom}
      modalTitle={MENU.IMPORTING_PACKAGE_CATEGORY_MASTER}
      draggerTitle={ACTIONS.UPLOAD_PACKAGE_CATEGORY}
      draggerDescription={DESCRIPTIONS.UPLOAD_PACKAGE_CATEGORY_CSV}
      createImportJob={(formValue, dcId) =>
        createPackageCategoryImportJob({
          tenantKey,
          dto: { ...formValue, dcId }
        })
      }
      successMessage={SUCCESS_MESSAGES.STARTED_PACKAGE_CATEGORY_IMPORT}
      errorMessage={ERROR_MESSAGES.FAILED_TO_PACKAGE_CATEGORY_IMPORT}
      historyRoute="/$tenantKey/settings/package-category-import-jobs"
    />
  )
}
